import React from 'react';

import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import EyeOpenStrikethroughIcon from '@atlaskit/icon/core/eye-open-strikethrough';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import { ButtonItem, Section } from '@atlaskit/menu';
import Popup from '@atlaskit/popup';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Stack, xcss } from '@atlaskit/primitives';

import { messages } from './messages';

const overflowMenu = xcss({
	opacity: 0,
	width: '0px', // hide it by making it very small. We need it in the DOM so that it's focusable
	':focus-within': {
		opacity: 1,
		width: 'auto',
	},
});

const overflowMenuVisible = xcss({
	opacity: 1,
	width: 'auto',
	marginLeft: 'space.100',
});

interface FilterMenuProps {
	isVisible?: boolean;
	isMenuOpen?: boolean;
	onClick?: (ev: React.MouseEvent | React.KeyboardEvent) => void;
	onClose?: (ev: React.MouseEvent | React.KeyboardEvent) => void;
	onClickMenuItem?: (ev: React.MouseEvent | React.KeyboardEvent, action: string) => void;
}

const FilterMenu = ({
	isVisible,
	isMenuOpen = false,
	onClick,
	onClickMenuItem,
	onClose,
}: FilterMenuProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={[isVisible ? overflowMenuVisible : overflowMenu]}>
			<Popup
				isOpen={isMenuOpen}
				onClose={onClose}
				placement="bottom-end"
				content={() => (
					<Stack>
						<Section>
							<ButtonItem
								iconBefore={<EyeOpenStrikethroughIcon label="" />}
								onClick={(ev) => {
									ev.stopPropagation();
									onClickMenuItem?.(ev, 'hide');
									onClose?.(ev);
								}}
							>
								{formatMessage(messages.hideMenuItemLabel)}
							</ButtonItem>
						</Section>
					</Stack>
				)}
				trigger={(triggerProps) => (
					<IconButton
						{...triggerProps}
						onClick={onClick}
						label={formatMessage(messages.menuTriggerLabel)}
						icon={ShowMoreHorizontalIcon}
						appearance="subtle"
						spacing="compact"
					/>
				)}
			/>
		</Box>
	);
};

export default FilterMenu;
